import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ExclusiveAvatarButton from '../ExclusiveAvatarButton';

import s from './ExclusiveAvatarGreetingsModal.scss';

export interface Props {
  /** Callback when modal is closed */
  onClose?: () => void;
  /** Callback when user clicks Shop Exclusive Avatars */
  onShopClick?: () => void;
  /** Callback when user clicks Learn more */
  onLearnMoreClick?: () => void;
  /** Image URL for the Halloween masks */
  imageUrl?: string;
}

/**
 * Greetings modal for exclusive avatars Halloween feature
 * Shows announcement about exclusive avatars with CTA to shop
 */
const ExclusiveAvatarGreetingsModal: React.FC<Props> = ({
  onClose,
  onShopClick,
  onLearnMoreClick,
  imageUrl = 'https://st.deviantart.net/eclipse/illustrations/halloween_2026_masks.png',
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      heading=" "
      headerClassName={s['header']}
      headerPadding="slim"
      className={s['modal']}
      contentClassName={s['modal-content']}
    >
      <div className={s['content']}>
        <div className={s['text-content']}>
          <p className={s['label']}>
            {t('commentBox.exclusiveAvatars.greetingsModal.label')}
          </p>
          <h2 className={s['title']}>
            {t('commentBox.exclusiveAvatars.greetingsModal.title')}
          </h2>
          <p className={s['description']}>
            {t('commentBox.exclusiveAvatars.greetingsModal.description')}
          </p>
        </div>

        <div className={s['image-container']}>
          <img src={imageUrl} alt="Halloween masks" className={s['image']} />
        </div>

        <div className={s['actions']}>
          <ExclusiveAvatarButton
            onClick={onShopClick}
            className={s['shop-button']}
          >
            {t('commentBox.exclusiveAvatars.greetingsModal.cta')}
          </ExclusiveAvatarButton>
          <TextButton size="small" variant="main" onClick={onLearnMoreClick}>
            {t('common.learnMore')}
          </TextButton>
        </div>
      </div>
    </Modal>
  );
};

ExclusiveAvatarGreetingsModal.displayName = 'ExclusiveAvatarGreetingsModal';

export default ExclusiveAvatarGreetingsModal;
